export default {
  currentPeriod: 'Período recente',
  displacedPeriod: 'Período anterior',
};
